import StudentParentContact from "./src/main";

/* istanbul ignore next */
StudentParentContact.install = function (Vue) {
  Vue.component(StudentParentContact.name, StudentParentContact);
};

export default StudentParentContact;
